import { getAmpConfig } from 'shared/config/amp-config';

export const getFreeToPaidBffUrl = () => {
  return `${getAmpConfig().gateway}/ftp-bff`;
};
